/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SourceId
 */
export interface SourceId {
    /**
     * 
     * @type {string}
     * @memberof SourceId
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof SourceId
     */
    originalName: string;
    /**
     * 
     * @type {boolean}
     * @memberof SourceId
     */
    valid: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SourceId
     */
    rejected?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SourceId
     */
    approved?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SourceId
     */
    createdBySystem?: boolean;
}

/**
 * Check if a given object implements the SourceId interface.
 */
export function instanceOfSourceId(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "originalName" in value;
    isInstance = isInstance && "valid" in value;

    return isInstance;
}

export function SourceIdFromJSON(json: any): SourceId {
    return SourceIdFromJSONTyped(json, false);
}

export function SourceIdFromJSONTyped(json: any, ignoreDiscriminator: boolean): SourceId {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'originalName': json['original_name'],
        'valid': json['valid'],
        'rejected': !exists(json, 'rejected') ? undefined : json['rejected'],
        'approved': !exists(json, 'approved') ? undefined : json['approved'],
        'createdBySystem': !exists(json, 'created_by_system') ? undefined : json['created_by_system'],
    };
}

export function SourceIdToJSON(value?: SourceId | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'original_name': value.originalName,
        'valid': value.valid,
        'rejected': value.rejected,
        'approved': value.approved,
        'created_by_system': value.createdBySystem,
    };
}

